import type { Angebot } from "./typen";

/* ══════════════════════════════════════════════════════════════════
   Die Zählung der Angebote — eine für den Kopf, die Startseite und die Liste
   (Prüfrunde Runde 9, N9-03, 05.10.2026).

   Vera sah am Telefon „Angebote · Keins wartet auf eine Antwort" und
   darunter „Offen 2" — einer davon ein Auftrag im Abschluss, der nie ein
   Angebot war. Die API nimmt ihn jetzt nicht mehr in die Angebotsliste
   (`IM_ABSCHLUSS`, apps/api/src/dienste/angebotszahlen.ts) und liefert die
   Zählung mit, die auch `GET /start` liest. Der Kopf liest sie; nur die
   Attrappe zählt sie hier aus der Liste — nach denselben Regeln.

   **Der Kopf zählt, was der Reiter „Offen" zeigt**: versendet (wartet auf
   Antwort) und im Entwurf. Was null ist, steht nicht da.
   ══════════════════════════════════════════════════════════════════ */

export type Angebotszahlen = {
  /** Versendet — der Kunde ist am Zug. */
  wartet: number;
  /** Davon läuft die Bindefrist ab. */
  eilt: number;
  /** Im Entwurf — bei uns, noch nicht versendet. */
  entwurf: number;
};

/** Dieselbe Zählung aus den Zeilen — für die Attrappe und als Rückfall. */
export function angebotszahlenAus(zeilen: Pick<Angebot, "phase" | "eilt">[]): Angebotszahlen {
  return {
    wartet: zeilen.filter((a) => a.phase === "versendet").length,
    eilt: zeilen.filter((a) => a.eilt && a.phase === "versendet").length,
    entwurf: zeilen.filter((a) => a.phase === "entwurf").length,
  };
}

/** Die Teile der Kopfzeile am Telefon: i18n-Schlüssel und Zahl, ohne Nullen. */
export function kopfteile(z: Angebotszahlen): { key: string; zahl: number }[] {
  return [
    { key: "angebote.telefonOffen", zahl: z.wartet },
    { key: "angebote.telefonEntwurf", zahl: z.entwurf },
    { key: "angebote.telefonEilt", zahl: z.eilt },
  ].filter((teil) => teil.zahl > 0);
}
